var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('wo-pill',{staticClass:"wo-pill--sm",attrs:{"mod-error":_vm.modError,"mod-success":_vm.modSuccess,"mod-warning":_vm.modWarning,"mod-xs":""}},[_c('po-display',{attrs:{"value":_vm.value}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }